import React from "react";
import AntdTable from "../../../components/common/AntdTable";
import { Card, Row, Col, Typography, Divider } from "antd";

const { Text, Title } = Typography;

const IncomeStatementTable = ({ incomeStatementData = {} }) => {
  const incomeColumns = [
    {
      title: "ACCOUNT NAME",
      dataIndex: "accountName",
      width: 300,
    },
    {
      title: "AMOUNT",
      dataIndex: "amount",
      align: "right",
      width: 200,
      render: (amount) =>
        amount ? `UGX ${amount?.toLocaleString()}` : "UGX 0",
    },
  ];

  const expenditureColumns = [
    {
      title: "ACCOUNT NAME",
      dataIndex: "accountName",
      width: 300,
    },
    {
      title: "AMOUNT",
      dataIndex: "amount",
      align: "right",
      width: 200,
      render: (amount) =>
        amount ? `UGX ${amount?.toLocaleString()}` : "UGX 0",
    },
  ];

  // Extract data from response
  const incomeData = incomeStatementData?.income?.items || [];
  const totalIncome = incomeStatementData?.income?.total || 0;
  const expenditureData = incomeStatementData?.expenditure?.items || [];
  const totalExpenditure = incomeStatementData?.expenditure?.total || 0;
  const surplusDeficit = incomeStatementData?.surplusDeficit || 0;

  // Add totals row to income
  const incomeWithTotal = [
    ...incomeData,
    {
      accountName: "TOTAL INCOME",
      amount: totalIncome,
      key: "income-total",
    },
  ];

  // Add totals row to expenditure
  const expenditureWithTotal = [
    ...expenditureData,
    {
      accountName: "TOTAL EXPENDITURE",
      amount: totalExpenditure,
      key: "expenditure-total",
    },
  ];

  return (
    <div>
      {/* Income and Expenditure in Two Columns */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: 16 }}>
        {/* Income Section */}
        <Card
          size="small"
          title={<Title level={5} style={{ margin: 0 }}>INCOME</Title>}
        >
          <AntdTable
            columns={incomeColumns}
            pagination={false}
            data={incomeWithTotal}
            rowClassName={(record) =>
              record.key === "income-total" ? "income-statement-total-row" : ""
            }
          />
        </Card>

        {/* Expenditure Section */}
        <Card
          size="small"
          title={<Title level={5} style={{ margin: 0 }}>EXPENDITURE</Title>}
        >
          <AntdTable
            columns={expenditureColumns}
            pagination={false}
            data={expenditureWithTotal}
            rowClassName={(record) =>
              record.key === "expenditure-total"
                ? "income-statement-total-row"
                : ""
            }
          />
        </Card>
      </div>

      {/* Surplus/Deficit Summary */}
      <Card
        size="small"
        style={{ marginTop: 16 }}
        bodyStyle={{ padding: "16px 24px" }}
      >
        <Row gutter={16} justify="space-between" align="middle">
          <Col>
            <Text strong style={{ fontSize: "16px" }}>
              {surplusDeficit >= 0 ? "SURPLUS" : "DEFICIT"} FOR THE PERIOD:
            </Text>
          </Col>
          <Col>
            <Text
              strong
              style={{
                fontSize: "18px",
                color: surplusDeficit >= 0 ? "#52c41a" : "#ff4d4f",
              }}
            >
              UGX {Math.abs(surplusDeficit).toLocaleString()}
            </Text>
          </Col>
        </Row>
        <Divider style={{ margin: "12px 0" }} />
        <Row gutter={16} justify="end">
          <Col>
            <Text strong>Total Income: </Text>
            <Text>UGX {totalIncome.toLocaleString()}</Text>
          </Col>
          <Col style={{ marginLeft: 24 }}>
            <Text strong>Total Expenditure: </Text>
            <Text>UGX {totalExpenditure.toLocaleString()}</Text>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default IncomeStatementTable;



